import {
	CheckCircleIcon,
	InfoIcon,
	SpinnerIcon,
	WarningIcon,
	XCircleIcon,
} from "@phosphor-icons/react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

import { useTheme } from "@/components/theme/theme-provider";

const Toaster = ({ ...props }: ToasterProps) => {
	const { theme = "system" } = useTheme();

	return (
		<Sonner
			theme={theme as ToasterProps["theme"]}
			className="toaster group"
			icons={{
				success: <CheckCircleIcon weight="fill" className="size-4" />,
				info: <InfoIcon weight="fill" className="size-4" />,
				warning: <WarningIcon weight="fill" className="size-4" />,
				error: <XCircleIcon weight="fill" className="size-4" />,
				loading: <SpinnerIcon className="size-4 motion-safe:animate-spin" />,
			}}
			style={
				{
					"--normal-bg": "var(--card)",
					"--normal-text": "var(--card-foreground)",
					"--normal-border":
						"color-mix(in oklch, var(--foreground) 10%, transparent)",
					"--border-radius": "var(--radius-xl)",
					"--success-bg": "var(--card)",
					"--success-text": "var(--card-foreground)",
					"--success-border":
						"color-mix(in oklch, var(--foreground) 10%, transparent)",
					"--error-bg": "var(--card)",
					"--error-text": "var(--card-foreground)",
					"--error-border":
						"color-mix(in oklch, var(--foreground) 10%, transparent)",
					"--info-bg": "var(--card)",
					"--info-text": "var(--card-foreground)",
					"--info-border":
						"color-mix(in oklch, var(--foreground) 10%, transparent)",
					"--warning-bg": "var(--card)",
					"--warning-text": "var(--card-foreground)",
					"--warning-border":
						"color-mix(in oklch, var(--foreground) 10%, transparent)",
				} as React.CSSProperties
			}
			toastOptions={{
				classNames: {
					toast: "cn-toast !shadow-md !ring-1 !ring-foreground/10 !border-none",
					title: "!text-sm !font-medium",
					description: "!text-muted-foreground !text-xs",
					success: "!text-primary",
					error: "!text-destructive",
					info: "!text-primary",
					warning: "!text-accent",
				},
			}}
			{...props}
		/>
	);
};

export { Toaster };
